import React, { useState, useEffect } from 'react';
import { Modal } from '@heartinternet/hi-ui';
import { Text } from '@heartinternet/hi-ui';
import { Input } from '@heartinternet/hi-ui';
import { Button } from '@heartinternet/hi-ui';
import { Flex } from '@heartinternet/hi-ui';

interface RenameGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  currentName: string;
  onRename: (newName: string) => void;
}

export const RenameGroupModal: React.FC<RenameGroupModalProps> = ({
  isOpen,
  onClose,
  currentName,
  onRename,
}) => {
  const [name, setName] = useState(currentName);

  /* eslint-disable react-hooks/set-state-in-effect -- sync name with prop when modal opens */
  useEffect(() => {
    if (isOpen) setName(currentName);
  }, [isOpen, currentName]);
  /* eslint-enable react-hooks/set-state-in-effect */

  const handleSubmit = () => {
    const trimmed = name.trim();
    if (trimmed && trimmed !== currentName) {
      onRename(trimmed);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Rename Group" size="small">
      <Flex direction="column" gap="md">
        <Text variant="body">Enter a new name for the group.</Text>
        <Input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleSubmit();
          }}
          size="sm"
          fullWidth
          autoFocus
        />
        <Flex direction="row" gap="sm">
          <Button
            variant="primary"
            size="small"
            onClick={handleSubmit}
            disabled={!name.trim() || name.trim() === currentName}
          >
            Rename
          </Button>
          <Button variant="tertiary" size="small" onClick={onClose}>
            Cancel
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
